(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mox-pagination-load-more"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', async (e) => {
    const btn = e.target.closest('.mox-load-more__button');
    if (!btn) return;

    e.preventDefault();

    const url = btn.href;
    const originalText = btn.textContent.trim();

    btn.textContent = 'Cargando...';
    btn.setAttribute('aria-busy', 'true');
    btn.style.pointerEvents = 'none';

    const currentGrid = document.querySelector('[ref="grid"]');
    const existingCards = currentGrid
      ? Array.from(currentGrid.querySelectorAll(':scope > [ref="cards[]"]'))
      : [];
    const template = existingCards[existingCards.length - 1];
    const pageSize = Number(btn.dataset.pageSize) || existingCards.length;
    const skeletons = [];

    // Reserva el alto de las próximas cards antes del fetch para evitar layout shift al appendear
    if (currentGrid && template) {
      for (let i = 0; i < pageSize; i++) {
        const skeleton = template.cloneNode(true);
        skeleton.classList.add('mox-load-more__skeleton');
        skeleton.setAttribute('aria-hidden', 'true');
        skeleton.inert = true;
        skeleton.removeAttribute('id');
        skeleton.querySelectorAll('[id]').forEach((node) => node.removeAttribute('id'));
        currentGrid.append(skeleton);
        skeletons.push(skeleton);
      }
    }

    try {
      const response = await fetch(url);
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const newGrid = doc.querySelector('[ref="grid"]');

      if (newGrid && currentGrid) {
        const newCards = Array.from(newGrid.querySelectorAll(':scope > [ref="cards[]"]'));
        newCards.forEach((card, index) => {
          const skeleton = skeletons[index];
          if (skeleton) {
            skeleton.replaceWith(card);
          } else {
            currentGrid.append(card);
          }
        });
        skeletons.slice(newCards.length).forEach((skeleton) => skeleton.remove());
      }

      const currentLoadMore = document.querySelector('.mox-load-more');
      const newLoadMore = doc.querySelector('.mox-load-more');

      if (currentLoadMore) {
        if (newLoadMore) {
          currentLoadMore.insertAdjacentHTML('afterend', newLoadMore.outerHTML);
          currentLoadMore.remove();
        } else {
          currentLoadMore.remove();
        }
      }

      history.pushState(null, '', url);

    } catch {
      skeletons.forEach((skeleton) => skeleton.remove());
      btn.textContent = originalText;
      btn.removeAttribute('aria-busy');
      btn.style.pointerEvents = '';
    }
  });
  } catch(e) { console.error(e); }
})();

})();
